import type {Recommendation} from './Recommendation.js'
import type {MergedRecommendation} from './MergedRecommendation.js'
import {MergedRecommendationId} from './MergedRecommendationId.js'

export const isMergedRecommendation = (
  recommendation: Recommendation | MergedRecommendation,
): recommendation is MergedRecommendation => {
  return MergedRecommendationId.safeParse(recommendation.id).success
}
